import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Breadcrumb from "./Essentials/Breadcrumb/Breadcrumb";
import Header from "./Essentials/Header/Header";
import ChipsSection from "./Essentials/ChipsSection/ChipsSection";
import GroupsProductSection from "./Essentials/GroupsProductSection/GroupsProductSection";
import { Helmet } from 'react-helmet';


const NewCoursesDashboard = ({ MetaTitle, MetaKeywords, MetaDescription, Case, BreadcrumbData, HeadingText, SubHeadingText, ChipsData, GroupsProductData }) => {
    const [selectedMedium, setSelectedMedium] = useState("");
    const navigate = useNavigate();

    const location = useLocation();
    const canonicalUrl = `${window.location.origin}${location.pathname}`;

    return (
        <>
            <Helmet>
                <title>{MetaTitle}</title>
                <meta name="description" content={MetaDescription} />
                <meta name="keywords" content={MetaKeywords} />
                <meta property="og:title" content={MetaTitle} />
                <meta property="og:description" content={MetaDescription} />
                <link rel="canonical" href={canonicalUrl} />
            </Helmet>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
                {/* Breadcrumb Section */}
                <Breadcrumb 
                    BreadcrumbData={BreadcrumbData} 
                />
                {/* Header Section - Heading, Sub Heading, Language Filter */}
                <Header 
                    selectedMedium={selectedMedium} 
                    setSelectedMedium={setSelectedMedium} 
                    HeadingText={HeadingText} 
                    SubHeadingText={SubHeadingText} 
                />
                {/* Chips Section */}
                {
                    Case != 3
                    &&
                    (
                        <ChipsSection
                            ChipsData={ChipsData}
                        />
                    )
                }
                
                {/* Working */}
                <div className="mt-6">
                    <GroupsProductSection
                        Case={Case}
                        GroupsProductData={GroupsProductData}
                        selectedMedium={selectedMedium}
                    />
                </div>
                <style>{`
                    .scrollbar-hide::-webkit-scrollbar {
                        display: none;
                    }
                    .scrollbar-hide {
                        -ms-overflow-style: none;
                        scrollbar-width: none;
                    }
                `}</style>
            </div>
        </>
    );
};

export default NewCoursesDashboard;